import { ThunkAction } from '../../infrastructure/store.interface';
import * as audiencesService from '../../services/audiences.service';
import { audiencesActions } from '../actionTypes/audiences';
import { AudiencesTabs } from '../reducers/audiences';
import { triggerRowAnimation } from '../../components/AppTable/AppTable';
import { IIntegrationProperty } from '@walkme/audiences-types';
import { Locations } from '../../models/locations';
import { AppTableRowAnimateType, ITableData } from '../../components/AppTable/model';
import { AudienceGraphql } from '../../../generated/apollo-hooks';
import { AccountsSdk } from 'wm-accounts-sdk';
import config from '../../config/config';
import { History } from '../../components/NavigateSetter'

export const addAudiencesProcessingRowIds = (tableKey: AudiencesTabs, audiences: AudienceGraphql[]): ThunkAction => (dispatch, getState) => {
    const tableData = getState().audiences.tableState[tableKey];
    const clone = new Map(tableData.animateIds);

    audiences.forEach(audience => {
        if (audience.id) {
            clone.set(audience.id, AppTableRowAnimateType.process);
        }
    });

    dispatch(updateAudiencesTableState(tableKey, { animateIds: clone }));
};

export const removeAudiencesProcessingRowIds = (tableKey: AudiencesTabs, audiences: AudienceGraphql[]): ThunkAction => (dispatch, getState) => {
    const tableData = getState().audiences.tableState[tableKey];
    const clone = new Map(tableData.animateIds);

    audiences.forEach(audience => {
        if (audience.id) {
            if (clone.get(audience?.id) === AppTableRowAnimateType.process) {
                clone.delete(audience?.id);
            }
        }
    });

    dispatch(updateAudiencesTableState(tableKey, { animateIds: clone }));
};

export const triggerRowAnimationAction = ({
    animateType,
    ids,
    result,
    onDoneBulk
}: {
    animateType: AppTableRowAnimateType;
    ids: string[];
    result?: $TSFixMe;
    onDoneBulk?: (results: $TSFixMe[]) => $TSFixMe;
}): ThunkAction => async (dispatch, getState) => {
    const currentTab = getState().audiences.currentTab;
    const { pathname } = History.location()

    if (pathname === Locations.Audiences) {
        return triggerRowAnimation({
            animateType,
            ids,
            getValue: () => getState().audiences.tableState[currentTab].animateIds,
            onChange: animateIds => dispatch(updateAudiencesTableState(currentTab, { animateIds })),
            result,
            onDoneBulk
        });
    } else {
        await onDoneBulk?.([result]);
    }
};

export const updateAudiencesTableState = (key: AudiencesTabs, changes: Partial<ITableData>) => ({
    type: audiencesActions.UPDATE_AUDIENCES_TABLE_STATE,
    payload: { key, changes }
});

export const loadIntegrationsDataProperty = ({ integrationId, property }: Partial<IIntegrationProperty>): ThunkAction => async (
    dispatch,
    getState
) => {
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
    let data = getState().audiences?.integrationsDataProperties?.[integrationId]?.[property];

    if (!data) {
        ({ data } = await audiencesService.loadIntegrationsDataProperty({ integrationId, property }));
        // data = getState().audiences?.integrationsData?.find(item => item.integrationId === integrationId && item.property === property);

        dispatch({
            type: audiencesActions.SET_INTEGRATIONS_DATA_PROPERTY,
            payload: { integrationId, property: data }
        });
    }

    return data;
};

export const manageIntegrations = (): ThunkAction => async (dispatch, getState) => {
    const systemId = getState().common.currentSystem;
    const systems = getState().common.systems;
    const systemNumericId = systems[systemId].id;
    // if system was switched on another tab for some reason, in order to be redirected to system you are expecting
    await AccountsSdk.getInstance().switchSystem(systemNumericId);

    window.open(`${config.manageIntegrationsHost}/backoffice/integrations?forceRefreshToken=true`, '_blank');
};
